import { render } from "./IconListAlt.vue?vue&type=template&id=79163358"
import script from "./IconListAlt.vue?vue&type=script&lang=js"
export * from "./IconListAlt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__